import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[inView]',
    standalone: false
})
export class LazyLoadDirective implements OnInit, OnDestroy {

  private observer!: IntersectionObserver;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.elementRef.nativeElement.setAttribute('src', this.elementRef.nativeElement.getAttribute('data-src'));
          this.observer.unobserve(entry.target);
        }
      });
    });
    this.observer.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }

}
